import script from "./RfidProcessingListLogsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidProcessingListLogsPage.vue?vue&type=script&setup=true&lang=js"

import "./RfidProcessingListLogsPage.vue?vue&type=style&index=0&id=f6042dbc&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6042dbc"]])

export default __exports__